export enum OcppBackendName {
  Freshmile = 'Freshmile',
  Monta = 'Monta',
  EMobilityCockpit = 'eMobilityCockpit',
  Volta = 'Volta',
}

export const OcppBackendUrls: Record<OcppBackendName, string> = {
  [OcppBackendName.Freshmile]: 'ocppj.freshmile.com',
  [OcppBackendName.Monta]: 'ocpp.monta.app',
  [OcppBackendName.EMobilityCockpit]: 'ocppj.greenmotion.ch/ocppj/v1.6',
  [OcppBackendName.Volta]: 'volta.eeproperty.com/ocpp/v16',
};
